import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { resolveCanonicalOriginRedirect } from "./app/canonicalOriginRedirect";
import { createWebStudioQueryClient } from "./app/queryClient";
import { BootRefreshProvider } from "./app/refresh";
import { router } from "./app/router";
import { ThemeProvider } from "./design";
import "./design/design.css";
import "./styles.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Web Studio root element is missing from index.html");
}

// The `pages.dev` production alias hands visitors to the canonical origin
// before any app code mounts (web-studio-auth-gate D4). Non-alias hosts
// (canonical origin, per-branch previews, localhost) resolve to null
// immediately, and any metadata failure resolves to "no redirect".
void resolveCanonicalOriginRedirect(window.location).then((redirectTarget) => {
  if (redirectTarget !== null) {
    window.location.replace(redirectTarget);
    return;
  }

  const queryClient = createWebStudioQueryClient();

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BootRefreshProvider>
            <RouterProvider router={router} />
          </BootRefreshProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
});
